/* eslint-disable arrow-body-style */
import { useState, useCallback, useMemo, useEffect } from 'react';
import { IUseFilterDataProps, TValue } from '../_type';

const useFilterData = (props: IUseFilterDataProps) => {
  const {
    value: valueProps,
    defaultValue,
    radioListContent,
    onOpen,
    onClose,
    onChange
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState<TValue>(valueProps || defaultValue);

  // 受控更新筛选器内部value值
  useEffect(() => {
    if (!valueProps) return;
    setValue(valueProps);
  }, [valueProps]);

  const { radioValue, errorMsg } = useMemo(()=>{
    return {
      radioValue: value?.radioSelectedValue,
      errorMsg: value?.inputValue?.errorMsg || ''
    };
  }, [value]);

  // 选中的radio配置
  const selectedRadio = useMemo(() => {
    return radioListContent?.filter((item: { value: any; }) => item?.value === radioValue)?.[0] || {};
  }, [radioListContent, radioValue]);

  // radioOptions选择change事件
  const handleChange = useCallback((val: string) => {
    // 如果选中项与输入框值相同，则不触发change事件,也防止重复点击置空
    // 如果对应radio配置了default，则直接返回默认值
    if(val !== value?.radioSelectedValue){
      const defaultVal = radioListContent?.filter((item: { value: string; }) => item?.value === val)?.[0]?.default || {};
      const {radioSelectedValue, inputValue} = defaultVal || {};
      const {max, min} = inputValue || {};
      const resultVal = {
        radioSelectedValue: radioSelectedValue ||  val,
        inputValue: {
          max: max || '',
          min: min || '',
          errorMsg: ''
        }
      };
      setValue(resultVal);
    }
    
  }, [value, selectedRadio]);

  // 子组件change事件回调
  const handleValueChange = useCallback((val: { max: string | number; min: string | number;errorMsg: string;}) => {
    const resultVal = {
      radioSelectedValue: value?.radioSelectedValue,
      inputValue: val
    };
    setValue(resultVal);
  }, [value]);

  // 打开下拉框
  const handleOpen = () => {
    setIsOpen(true);
    onOpen?.();
  };

  // 关闭下拉框
  const handleClose = () => {
    setIsOpen(false);
    onClose?.(value);
    setValue(valueProps);
  };
  
  // 确认，输出筛选器的值到外部筛选器
  const handleConfirm = () => {
    const {max, min} = value?.inputValue || {};
    const result = {
      radioSelectedValue: radioValue,
      inputValue: {
        max: max !== '' ? Number(max) : '',
        min: min !== '' ? Number(min) : '',
      }
    };
    onChange?.(result);
    setIsOpen(false);
  };

  return {
    radioValue,
    value,
    errorMsg,
    isOpen,
    setValue,
    selectedRadio,
    handleOpen,
    handleClose,
    handleChange,
    handleConfirm,
    handleValueChange
  };
};

export default useFilterData;
